import React from "react";
import PropTypes from "prop-types";

/**
 * Componente CommonDropdown
 *
 * @component
 * @param {Object} props - As propriedades do componente.
 * @param {ReactNode} props.children - O conteúdo a ser renderizado dentro do menu suspenso.
 * @returns {ReactElement} O elemento React renderizado que representa o menu suspenso.
 */
function CommonDropdown({ children }) {
  return (
    <div className="dropdown">
      <button
        className="dropdown-toggle card-drop"
        aria-label="card-drop"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        data-boundary="window"
      >
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </button>
      <ul className="dropdown-menu dropdown-menu-end">
        <li>{children}</li>
      </ul>
    </div>
  );
}

CommonDropdown.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CommonDropdown;
